import React, { useContext } from "react";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails";
import "./GoalkeeperSelect.scss";

const GoalkeeperSelect = ({
  entity,
  activeGks,
  setActiveGks,
  formatMessage,
}) => {
  const { sport } = useContext(FixtureDetailsContext);

  return (
    <div className="goalkeeper-select">
      <p>
        {formatMessage({
          id: `shootOut.goalkeeper`,
          defaultMessage: "Goalkeeper",
        })}
        : {entity.fullNameLatin}
      </p>
      <select
        onChange={(ev) =>
          setActiveGks({
            ...activeGks,
            [entity.entityId]: ev.target.value,
          })
        }
        value={activeGks[entity.entityId]}
      >
        <option>
          {formatMessage({
            id: `option.pleaseSelect`,
            defaultMessage: "Please select",
          })}
        </option>
        {entity.persons.
          map((person) => (
            <option key={person.personId} value={person.personId}>
              #{person.bib} - {person.name}
              {sport === "hockey" && person.position === "GK" ? " (GK)" : ""}
            </option>
          ))}
      </select>
    </div>
  );
};

export default GoalkeeperSelect;
